export const styles = theme => ({
    listItem: {
        listStyleType: "none",
        display: "flex",
        alignItems: "center",
        fontSize: "0.75rem"
    },
    invalidIcon: {
        color: "red",
        height: "1rem",
        width: "1rem"
    },
    validIcon: {
        color: "green",
        height: "1rem",
        width: "1rem"
    }
});
